/**
 * setSearchParams용 params 객체 생성 (Trainings 페이지에서 URL 동기화용)
 * @param {Object} pageInfo - { page, size, languageId, level, isApproval, categoryId, subCategoryId, problemId, sortBy, sortOrder }
 * @returns {Record<string, string>} - setSearchParams에 전달할 객체
 */
export const buildPageInfoParamsObject = (pageInfo) => {
  if (!pageInfo) return {};
  const params = {};
  if (pageInfo.page != null) params.page = String(pageInfo.page);
  if (pageInfo.size != null) params.size = String(pageInfo.size);
  if (pageInfo.languageId != null) params.languageId = String(pageInfo.languageId);
  if (pageInfo.level != null) params.level = String(pageInfo.level);
  if (pageInfo.isApproval !== null && pageInfo.isApproval !== undefined) params.isApproval = String(pageInfo.isApproval);
  if (pageInfo.categoryId != null) params.categoryId = String(pageInfo.categoryId);
  if (pageInfo.subCategoryId != null) params.subCategoryId = String(pageInfo.subCategoryId);
  if (pageInfo.problemId != null && pageInfo.problemId !== '') params.problemId = String(pageInfo.problemId);
  if (pageInfo.sortBy != null && pageInfo.sortBy !== '') params.sortBy = String(pageInfo.sortBy);
  if (pageInfo.sortOrder != null && pageInfo.sortOrder !== '') params.sortOrder = String(pageInfo.sortOrder);
  return params;
};

/**
 * URL search params에서 pageInfo 객체 파싱
 * @param {URLSearchParams} searchParams
 * @returns {{ pageInfo: Object, problemIdList: number[] }}
 */
export const parsePageInfoFromSearch = (searchParams) => {
  const pageInfo = {
    page: 1,
    size: 10,
    languageId: null,
    level: null,
    isApproval: null,
    categoryId: null,
    subCategoryId: null,
    problemId: '',
    sortBy: null,
    sortOrder: null,
  };
  const page = searchParams.get('page');
  if (page) pageInfo.page = parseInt(page, 10) || 1;
  const size = searchParams.get('size');
  if (size) pageInfo.size = parseInt(size, 10) || 10;
  const languageId = searchParams.get('languageId');
  if (languageId) pageInfo.languageId = parseInt(languageId, 10);
  const level = searchParams.get('level');
  if (level) pageInfo.level = level;
  const isApproval = searchParams.get('isApproval');
  if (isApproval !== null && isApproval !== undefined && isApproval !== '') {
    pageInfo.isApproval = isApproval === 'true';
  }
  const categoryId = searchParams.get('categoryId');
  if (categoryId) pageInfo.categoryId = parseInt(categoryId, 10);
  const subCategoryId = searchParams.get('subCategoryId');
  if (subCategoryId) pageInfo.subCategoryId = parseInt(subCategoryId, 10);
  const problemId = searchParams.get('problemId');
  if (problemId != null) pageInfo.problemId = problemId;

  const sortBy = searchParams.get('sortBy');
  if (sortBy) pageInfo.sortBy = sortBy;
  const sortOrder = searchParams.get('sortOrder');
  if (sortOrder && (sortOrder === 'asc' || sortOrder === 'desc')) {
    pageInfo.sortOrder = sortOrder;
  }

  const problemIdsStr = searchParams.get('problemIds');
  const problemIdList = problemIdsStr
    ? problemIdsStr.split(',').map((id) => parseInt(id.trim(), 10)).filter((id) => !Number.isNaN(id))
    : [];

  return { pageInfo, problemIdList };
};
